module.exports = __webpack_public_path__ + "img/northeast-fall-1200x550.9faf14e8.jpg";